export const TEST = {
  // Landing
  navLogin: "nav-login-btn",
  navGetStarted: "nav-get-started-btn",
  heroCta: "hero-cta-btn",
  heroLogin: "hero-login-btn",
  pricingPlan: (id) => `pricing-plan-${id}`,
  pricingCta: (id) => `pricing-cta-${id}`,

  // Auth
  authMobile: "auth-mobile-input",
  authSendOtp: "auth-send-otp-btn",
  authOtp: "auth-otp-input",
  authVerify: "auth-verify-otp-btn",
  authBack: "auth-back-btn",
  authDemoAdmin: "auth-demo-admin",
  authDemoSubscriber: "auth-demo-subscriber",
  authDemoHelper: "auth-demo-helper",

  // Shell
  shellLogout: "shell-logout-btn",
  shellNav: (k) => `shell-nav-${k}`,

  // Admin
  adminStatRevenue: "admin-stat-revenue",
  adminStatSubs: "admin-stat-subs",
  adminAddSubscriber: "admin-add-subscriber-btn",
  adminSaveSubscriber: "admin-save-subscriber-btn",
  adminToggleSub: (id) => `admin-toggle-sub-${id}`,

  // Subscriber
  subAddHelper: "sub-add-helper-btn",
  subSaveHelper: "sub-save-helper-btn",
  subToggleHelper: (id) => `sub-toggle-helper-${id}`,
  subSaveFees: "sub-save-fees-btn",
  subFeeSeller: "sub-fee-seller",
  subFeePurchaser: "sub-fee-purchaser",
  subFeeGatepass: "sub-fee-gatepass",

  // Helper
  helperAddSeller: "helper-add-seller-btn",
  helperSaveSeller: "helper-save-seller-btn",
  helperAddPurchaser: "helper-add-purchaser-btn",
  helperSavePurchaser: "helper-save-purchaser-btn",
  helperAddAnimal: "helper-add-animal-btn",
  helperSaveAnimal: "helper-save-animal-btn",
  helperAddCash: "helper-add-cash-btn",
  helperSaveCash: "helper-save-cash-btn",
  helperIssueGatepass: (id) => `helper-issue-gatepass-${id}`,
  helperExit: (id) => `helper-exit-${id}`,
  helperSaveExit: "helper-save-exit-btn",
};
